module.exports = __webpack_public_path__ + "img/moGaoKu4.9254119d.png";